import { Component, Input } from '@angular/core';
import * as _ from 'lodash';
import { IDetailViewFilter } from '../shared/models/detail-view-filter.interface';
import { DeviceLocationDeviceDetail } from '../shared/models/device-location-device-detail.interface';
import { DeviceLocationModuleDetail } from '../shared/models/device-location-module-detail.interface';
import { DeviceDetailFiltersService } from '../device-detail-filters/device-detail-filters.service';
import { DeviceStatusService } from '../shared/services/device-status.service';
import { DetailViewService } from '../shared/services/detail-view.service';

@Component({
    selector: 'dl-module-card',
    templateUrl: './module-card.component.html',
    styleUrls: ['./module-card.component.scss']
})
export class ModuleCardComponent {
    public static $name: string = 'dlModuleCard';

    @Input() module: DeviceLocationModuleDetail;

    filteredDevices: DeviceLocationDeviceDetail[];
    isFiltered: boolean;

    private oldFilter: IDetailViewFilter;

    constructor(
        private deviceDetailFilterService: DeviceDetailFiltersService,
        public detailViewService: DetailViewService,
        protected deviceStatusService: DeviceStatusService
    ) { }

    public ngDoCheck() {
        if(!_.isEqual(this.oldFilter,this.detailViewService.filter)){
            this.filterDevices();
            this.oldFilter = _.cloneDeep(this.detailViewService.filter);
        }

    }

    public ngOnInit() {
        this.oldFilter = _.cloneDeep(this.detailViewService.filter);
        this.filterDevices();
    }

    private filterDevices() {
        const unsortedDevices = this.deviceDetailFilterService.filterData(this.module.devices, this.detailViewService.filter);
        this.filteredDevices = unsortedDevices.sort((a, b) => this.sortDevices(a, b));
        this.isFiltered = (this.module.devices.length - this.filteredDevices.length) > 0;
    }

    // Devices of category 'Module' should always come first. Otherwise, sort by category, then sequence.
    private sortDevices = (a: DeviceLocationDeviceDetail, b: DeviceLocationDeviceDetail): number => {
        const lowerCaseCategoryA = a.category.toLocaleLowerCase();
        const lowerCaseCategoryB = b.category.toLocaleLowerCase();
        if (lowerCaseCategoryA === 'module' && lowerCaseCategoryB !== 'module') {
            return -1;
        } else if (lowerCaseCategoryA !== 'module' && lowerCaseCategoryB === 'module') {
            return 1;
        }

        if (lowerCaseCategoryA !== lowerCaseCategoryB) {
            return this.nonNumericSortComparison(lowerCaseCategoryA, lowerCaseCategoryB);
        }

        // Sequence is a string for some reason, so try to convert to a number.
        // If either sequence isn't numeric, just compare strings.
        const sequenceA = Number(a.sequence);
        const sequenceB = Number(b.sequence);
        if (isNaN(sequenceA) || isNaN(sequenceB)) {
            return this.nonNumericSortComparison(a.sequence, b.sequence);
        }
        return sequenceA - sequenceB;
    }

    private nonNumericSortComparison(a: string, b: string) {
        if (a > b) {
            return 1;
        } else if (a < b) {
            return -1;
        }
        return 0;
    }

    getModuleTitle(): string {
        return this.module.customName;
    }

    showMultiLineTitle(): boolean {
        return this.detailViewService.query.locationId > 0 || this.module.jobNumber > 0;
    }

    /**
     * In case location is zero or not set or moduleOrLocationOrJobNumber flag is set show location title
     */
    showLocationTitle(): boolean {
        return this.detailViewService.query.locationId <= 0 || this.detailViewService.query.moduleOrLocationOrJobNumber;
    }
}
